export default "__VITE_ASSET__DHE5PwFJ__"